import {
  ClearFiltersButton,
  FiltersHeader,
  FiltersPanel,
} from './catalogStyles';
import { FilterSection } from './FilterSection';

export const CatalogFilters = ({
  subCategoryOptions,
  segmentOptions,
  selected,
  onToggle,
  onClear,
  hasActiveFilters,
}) => (
  <FiltersPanel>
    <FiltersHeader>
      <strong>Filtros</strong>
      <ClearFiltersButton
        type="button"
        onClick={onClear}
        disabled={!hasActiveFilters}
      >
        Limpar filtros
      </ClearFiltersButton>
    </FiltersHeader>

    <FilterSection
      title="Subcategoria"
      options={subCategoryOptions}
      selected={selected.subCategoryIds}
      onToggle={(value) => onToggle('subCategoryIds', value)}
      emptyHint="Selecione uma categoria para ver as subcategorias."
    />
    <FilterSection
      title="Tipo de produto"
      options={segmentOptions}
      selected={selected.segmentIds}
      onToggle={(value) => onToggle('segmentIds', value)}
      emptyHint="Nenhum tipo disponível."
    />
  </FiltersPanel>
);
